<template>
  <section>
    <el-button
      :type="btnType"
      :size="size"
      :icon="btnIcon"
      :loading="loading"
      class="cache-reload-btn"
      plain
      @click="handleCacheReload()"
    >
      {{btnLabel}}
    </el-button>
  </section>
</template>

<script>
import api from '@/api/channel'

export default {
  name: 'CacheReload',
  props: {
    form: Object,
    btnType: {
      type: String,
      default: 'warning'
    },
    size: {
      type: String,
      default: 'small'
    },
    btnLabel: {
      type: String,
      default: '重载配置'
    },
    btnIcon: {
      type: String,
      default: 'el-icon-warning-outline'
    },
    reloadType: {
      type: String,
      required: true
    }
  },
  data () {
    const reloadTypeUrls = {
      game: '/channel/admin/cache/reload/game',
      channel: '/channel/admin/cache/reload/channel',
      xsArgsLogin: '/channel/admin/cache/reload/xsArgs/login',
      xsArgsPay: '/channel/admin/cache/reload/xsArgs/pay',
      mchGroup: '/channel/admin/cache/reload/mch/group',
      mchWx: '/channel/admin/cache/reload/mch/wx',
      mchAli: '/channel/admin/cache/reload/mch/ali',
      mchApple: '/channel/admin/cache/reload/mch/apple',
      extGameConfig: '/channel/admin/cache/reload/ext/config/game',
      extChannelConfig: '/channel/admin/cache/reload/ext/config/channel'
    }
    return {
      reloadTypeUrls: reloadTypeUrls,
      loading: false
    }
  },
  computed: {
    appId () {
      return this.$store.getters.appId
    }
  },
  methods: {
    getReloadUrl () {
      return this.reloadTypeUrls[this.reloadType]
    },
    handleCacheReload () {
      const url = this.getReloadUrl()
      if (!url) {
        this.$message.error('[err]组件错误: reloadType 不存在')
        return
      }
      this.$confirm(`确定要立即${this.btnLabel}吗？该操作会调用后端重载接口。`, '重载确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const params = { appId: this.appId }
        this.loading = true
        api.cacheReload(url, params).then(() => {
          this.$message.success(`${this.btnLabel}成功`)
        }).catch(() => {
          this.$message.error(`${this.btnLabel}失败`)
        }).finally(() => {
          this.loading = false
        })
      }).catch(() => {
        this.$message.info('已取消重载')
      })
    }
  }
}
</script>

<style scoped>
.cache-reload-btn {
  height: 32px;
  padding: 0 16px;
  border-radius: 8px !important;
  font-weight: 600 !important;
  background-color: #fff7ed !important;
  border-color: #fed7aa !important;
  color: #c2410c !important;
}

.cache-reload-btn:hover,
.cache-reload-btn:focus {
  background-color: #ffedd5 !important;
  border-color: #fdba74 !important;
  color: #9a3412 !important;
}
</style>
